import * as React from "react";
import {withCommentContext} from "./commentContext";
import {withLikeStatusContext} from "./likeStatusContext";
import {withLikeCountContext} from "./likeCountContext";
import {withEventContext} from "./eventContext";
import {useEvent} from "./hooks/useEvent";
import {useScreen} from "./hooks/useScreen";
import EventDetailCardRender from "./EventDetailCardRender"

const EventDetailCard = ({eventToSee}) => {
    console.log(eventToSee);
    const {theEvent} = useScreen();
    const {theEventDetail} = useEvent(eventToSee === undefined ? theEvent.id : eventToSee.id);

    return (
        <EventDetailCardRender theEvent={theEventDetail}></EventDetailCardRender>
    )
}

//export default EventDetailCard;
export default withEventContext(EventDetailCard)

